import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    color: #2c2d7a;
`

export const MainTextSpan = styled.span`
    font-size: 5.625em;
`

export const SecondaryTextSpan = styled.span`
    font-size: 0.875em;
`

export const LinkHome = styled(Link)`
    color: #ea505b;
    font-weight: 600;
`
